const GetMerchantsParser = (data: any): any => {
  const retData: any = []
  data.response.map((item: any) => {
    const retItem = {
      name: item?.firstname ?? '',
      vpa: item?.businessVpa ?? '',
      businessName: item?.businessName ?? '',
      mid: item?.merchantId ?? '',
      tId: item?.terminalId ?? '',
      bankAccount: item?.banckAccount,
      status: item?.merchantStatus ?? '',
      type: item?.merchantType ?? '',
      acceptedPayments: [],
      limits: [],
      age: '',
      authorisedSignatory: '',
      dailyTransactionVolume: '',
      contact: item?.contact,
    }
    retData.push(retItem)
  })
  return retData
}

export { GetMerchantsParser }
